export const GET_ADMIN_FEATURE_PENDING = 'GET_ADMIN_FEATURE_PENDING';
export const GET_ADMIN_FEATURES_PENDING = 'GET_ADMIN_FEATURES_PENDING';
export const GET_ADMIN_FEATURE_FULFILLED = 'GET_ADMIN_FEATURE_FULFILLED';
export const GET_ADMIN_FEATURES_FULFILLED = 'GET_ADMIN_FEATURES_FULFILLED';
export const GET_ADMIN_FEATURE_REJECTED = 'GET_ADMIN_FEATURE_REJECTED';
export const GET_ADMIN_FEATURES_REJECTED = 'GET_ADMIN_FEATURES_REJECTED';

export default function featuresTogglesReducer(state = {
    fetching: false,
    fetched: false,
    featureToggle: {},
    featureToggles: []
}, action) {
  switch (action.type) {
    case GET_ADMIN_FEATURE_PENDING:
    case GET_ADMIN_FEATURES_PENDING: {
      return {...state, fetching: true, fetched: false}
    }
    case GET_ADMIN_FEATURE_FULFILLED: {
      return {
        ...state,
        fetching: false,
        fetched: true,
        featureToggle: action.payload.data
      }
    }
    case GET_ADMIN_FEATURES_FULFILLED: {
      return {
        ...state,
        fetching: false,
        fetched: true,
        featureToggles: action.payload.data
      }
    }
    case GET_ADMIN_FEATURE_REJECTED: {
      return {
        ...state, 
        fetching: false,
        fetched: false,
        featureToggle: {}
      }
    }
    case GET_ADMIN_FEATURES_REJECTED: {
      return {
        ...state, 
        fetching: false,
        fetched: false,
        featureToggles: []
      }
    }
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/featureTogglesReducer.js